import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Photo from "./Photo";
import VideoPlayer from "./VideoPlayer";

const SchoolEnvironment = () => {
  const [environments, setEnvironments] = useState([]);
  useEffect(() => {
    axios.get("JSON/environments.json").then((response) => {
      setEnvironments(response.data[0]);
    });
  }, []);
  return (
    <>
      <section className="e-school-environment">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="section-head">
                <h3 className="section-head-title">
                  {environments?.section_title}
                </h3>
                <p className="section-head-text">
                  {environments?.section_detail}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="e-school-environment-inner">
                <div className="row">
                  {environments?.gallery?.map((environment) =>
                    environment?.type === "photo" ? (
                      <Photo environment={environment} key={environment?.id} />
                    ) : (
                      <VideoPlayer
                        videoInfo={environment}
                        key={environment?.id}
                      />
                    )
                  )}
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="e-school-env-bottom ">
                      <Link to="#" className="eschool-btn secondary-btn">
                        Load More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SchoolEnvironment;
